import React from 'react';
import { Navbar, Nav, NavItem, Dropdown, NavDropdown, Container, Image, Button, OverlayTrigger, Popover  } from 'react-bootstrap';
import uuid from 'react-uuid';
import axios, { AxiosRequestConfig } from 'axios';
import PropTypes from "prop-types";
import { Constants } from "../constants";
import { BrowserRouter as Router, Route, Link, NavLink, withRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

class GuestSiteMenu extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: props.user,
            currentPage: props.currentPage != null ? props.currentPage : 'self'
        };

        this.login = this.login.bind(this);
        this.feedback = this.feedback.bind(this);
        this.training = this.training.bind(this);
    }

    login() {
        this.props.history.push({
            pathname: '/'
        });
    }

    training() {
        this.props.history.push({
            pathname: "/training"
        });
    }

    feedback() {

        this.props.history.push({
            pathname: "/feedback",
            state: {
                previousPage: this.state.currentPage
            }
        });
    }

    render() {
        const popoverA = (
            <Popover id="popover-basic">
                <Popover.Body>
                    You are not currently logged in. Please&nbsp;
                    <Link target="_blank" to={{
                        pathname: "/"
                    }} style={{ marginTop: '10px' }}>login</Link> or&nbsp;
                    <Link target="_blank" to={{
                        pathname: "/register"
                    }} style={{ marginTop: '10px' }}>register</Link> for a portal account to track your Boland orders.
                </Popover.Body>
            </Popover>
        );
        const popoverB = (
            <Popover id="popover-basic">
                <Popover.Body>
                    You are not currently logged in. Please&nbsp;
                    <Link target="_blank" to={{
                        pathname: "/"
                    }} style={{ marginTop: '10px' }}>login</Link> or&nbsp;
                    <Link target="_blank"  to={{
                        pathname: "/register"
                    }} style={{ marginTop: '10px' }}>register</Link> for a portal account to access customer statements, building service reports, and more.
                </Popover.Body>
            </Popover>
        );
        return (
            <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded={false} sticky="top">
                <Container style={{ marginLeft: '0px', paddingRight: 0, maxWidth: '100%' }}>
                    <Navbar.Brand as={Link} to={{
                        pathname: "/"
                    }} style={{ margin: 0, padding: 0 }}>
                        <Image src="./Boland block 3.png" width="165px" height="40px" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto" style={{ width: '100%' }}>
                            <NavDropdown title="New Order" id="collasible-nav-dropdown" style={{ paddingLeft: '20px' }}>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/service_request",
                                    key: uuid()
                                }}>Service Request</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/rental_request",
                                    key: uuid()
                                }}>Rental Equipment</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/parts_request",
                                    key: uuid()
                                }}>Parts and Supplies</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Consultation" id="collasible-nav-dropdown">
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Equipment Inquiry"
                                    }
                                }}>Equipment Inquiry</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Control Solutions"
                                    }
                                }}>Control Solutions</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Service Contract"
                                    }
                                }}>Service Contract</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Indoor Air Quality"
                                    }
                                }}>Indoor Air Quality</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Energy Optimization"
                                    }
                                }}>Energy Optimization</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Building Performance"
                                    }
                                }}>Building Performance</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Water Technologies"
                                    }
                                }}>Water Technologies</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Rental Services"
                                    }
                                }}>Rental Services</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Capital Asset Planning"
                                    }
                                }}>Capital Asset Planning</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "Parts & Supplies Inventory Planning"
                                    }
                                }}>Parts & Supplies Inventory Planning</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        typeofrequest: "HVAC System Design & Build"
                                    }
                                }}>HVAC System Design & Build</Dropdown.Item>
                            </NavDropdown>
                            <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B', minWidth: 'fit-content' }} onClick={this.training}>
                                Training
                            </Button>
                            <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popoverA}>
                                <Button style={{ marginRight: 5, backgroundColor: '#1F419B', minWidth: 'max-content' }}>
                                    Tracking
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popoverB}>
                                <Button style={{ backgroundColor: '#1F419B', minWidth: 'max-content' }}>
                                    Reporting
                                </Button>
                            </OverlayTrigger>
                            <div style={{ width: '100%' }} />
                            <Button size="sm" className="justify-content-end button-feedback" style={{ justifyContent: 'end', backgroundColor: '#EF4139', minWidth: 'max-content' }} onClick={this.feedback}>
                                Feedback? Let us know here.
                            </Button>
                            <Nav.Link href="https://www.boland.com/news" target="_blank">News</Nav.Link>
                            <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B' }} onClick={this.login}>
                                Login/Register
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}
export default withRouter(GuestSiteMenu);